/* global axios */
import ApiClient from './ApiClient';

class BrandingSettingsAPI extends ApiClient {
  constructor() {
    super('branding_settings', { accountScoped: true });
  }

  update(data) {
    return axios.patch(this.url, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new BrandingSettingsAPI();
